<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>阿里云风险识别设置</span>
      </div>
      <el-form label-width="250px">
        <el-form-item label="是否开启">
          <el-switch v-model="form.open_status" active-color="#13ce66" inactive-color="#ff4949" />
        </el-form-item>
        <el-form-item label="风险用户缓存时间">
          <el-input class="input-b" type='number' v-model="form.cache_time" placeholder="请输入"></el-input>
          秒
        </el-form-item>
        <el-form-item label="用户注销上传样本接口是否开启">
          <el-switch v-model="form.upload_openid_open_status" active-color="#13ce66" inactive-color="#ff4949" />
        </el-form-item>
        <el-form-item label="login接口是否开启">
          <el-switch v-model="form.login_open_status" active-color="#13ce66" inactive-color="#ff4949" />
        </el-form-item>
        <el-form-item label="refresh_token接口是否开启">
          <el-switch v-model="form.refresh_token_open_status" active-color="#13ce66" inactive-color="#ff4949" />
        </el-form-item>
        <el-form-item label="create_order接口是否开启">
          <el-switch v-model="form.create_order_open_status" active-color="#13ce66" inactive-color="#ff4949" />
        </el-form-item>
      </el-form>
      <!-- <div style="text-align: center; margin-top: 20px">
        <el-button type="primary" @click="saveChange">保存</el-button>
      </div> -->
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>风险等级防控措施</span>
      </div>
      <el-form label-width="250px">
        <el-form-item label="高风险用户">
          <el-switch class="li-switch" inactive-text="订单拦截" v-model="form.high_all_intercept" active-color="#13ce66"
            inactive-color="#ff4949" />
<!--          <el-switch class="li-switch" inactive-text="拦截后群加黑" v-model="form.high_all_intercept_and_add_black_group" active-color="#13ce66"-->
<!--                     inactive-color="#ff4949" />-->
          <el-switch class="li-switch" inactive-text="拦截后用户加黑" v-model="form.high_all_intercept_and_add_black_user" active-color="#13ce66"
            inactive-color="#ff4949" />
        </el-form-item>
        <el-form-item label="中风险用户">
          <!-- <el-card class="content-cart">
            <div slot="header" class="clearfix">
              <span>非微信群来源下单</span>
            </div>
            <el-switch class="li-switch" inactive-text="验证码" v-model="form.medium_no_group_verify_code" active-color="#13ce66"
              inactive-color="#ff4949" />
          </el-card> -->
          <el-card class="content-cart">
            <div slot="header" class="clearfix">
              <span>微信群来源订单</span>
            </div>
            <el-switch class="li-switch" inactive-text="订单拦截" v-model="form.medium_is_group_intercept" active-color="#13ce66"
              inactive-color="#ff4949" />
            <el-switch class="li-switch" inactive-text="拦截后群加黑" v-model="form.medium_is_group_intercept_and_add_black_group" active-color="#13ce66"
                       inactive-color="#ff4949" />
            <el-switch class="li-switch" inactive-text="拦截后用户加黑" v-model="form.medium_is_group_intercept_and_add_black_user" active-color="#13ce66"
              inactive-color="#ff4949" />
          </el-card>
        </el-form-item>
      </el-form>
    </el-card>

    <div style="text-align: center; margin: 20px 0px">
      <el-button type="primary" @click="saveChange">保存设置</el-button>
    </div>
  </div>
</template>
<script>
import { getSettingInfo, setSettingInfo } from '@/api/trade'

export default {
  components: {
  },
  data() {
    return {
      form: {
        open_status: false,
        cache_time: '',
        upload_openid_open_status: false,
        login_open_status: false,
        refresh_token_open_status: false,
        create_order_open_status: false,
        high_all_intercept: false,
        high_all_intercept_and_add_black_group: false,
        high_all_intercept_and_add_black_user: false,
        medium_no_group_verify_code: false,
        medium_is_group_intercept: false,
        medium_is_group_intercept_and_add_black_group: false,
        medium_is_group_intercept_and_add_black_user: false
      }
    }
  },
  methods: {
    getDetail() {
      getSettingInfo().then(res => {
        this.form = res.data.data
      })
    },
    saveChange() {
      setSettingInfo(this.form).then(res => {
        this.$message({
          message: '设置成功',
          type: 'success'
        });
        this.getDetail()
      })
    }
  },
  mounted() {
    this.getDetail()
  }
}
</script>

<style scoped lang="scss">
.content-cart{
  width: 500px;
}

.li-switch{
  margin-right: 40px;
}
</style>
